// extracted by mini-css-extract-plugin
module.exports = {"form":"form-module--form--2tMfv","addToCartButton":"form-module--addToCartButton--2MIPF","waitlistButton":"form-module--waitlistButton--3AbtJ"};